import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { projectListSearchSchema } from "../../../../../features/projects/project-trash/project-list-search";
import { DealQuotesPage } from "../../../../../pages/deal-quotes-page/deal-quotes-page";

export const Route = createFileRoute("/_auth/_deal/deals/$dealId/quotes")({
  validateSearch: zodValidator(projectListSearchSchema),
  component: DealQuotesPage,
});
